module.exports = __webpack_public_path__ + "img/Vd4Gp.324ef590.gif";